import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertIdData, Notification } from '@usf/alert-types';
import { AlertTypeEnum } from '../../constants/constants';
import { UserService } from '@app/user/services';
import { take } from 'rxjs';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
})
export class NotificationCardComponent implements OnInit {
  @Input() notification: Notification;
  deeplink: string;
  messageBody: string;
  messageTitle: string;
  constructor(
    private translateService: TranslateService,
    readonly userService: UserService,
  ) {}

  ngOnInit() {
    if (this.notification) {
      this.deeplink = this.translateService.instant(
        AlertIdData.find(a => a.alertId === this.notification?.alertId)
          ?.linkLabel,
      );
      const isPaymentNotification =
        this.notification?.alertId === AlertTypeEnum.PYMT_DUE_THIS_WK ||
        this.notification?.alertId === AlertTypeEnum.PYMT_DUE_TODAY ||
        this.notification?.alertId === AlertTypeEnum.PYMT_PAST_DUE;
      if (isPaymentNotification) {
        this.userService
          .showInvoiceAndPaymentsMenu$()
          .pipe(take(1))
          .subscribe(menuLabel => {
            if (!menuLabel || menuLabel === 'i18n.moxe-links.invoices') {
              this.deeplink = '';
            }
          });
      }
      let messages = this.notification?.messageBody?.split(';');
      if (this.notification?.alertId === AlertTypeEnum.DELIVERY_EXCEPTION) {
        this.messageTitle = this.translateService.instant(
          'i18n.notifications.ctaLinkLabels.deliveryIssues',
        );
        if (messages.length === 5) {
          messages[5] = messages[1];
          messages[6] = messages[2];
          messages[2] = messages[0];
          messages.splice(0, 2);
        }
        messages = messages.map(message => {
          let regex = /\d+/;
          if (+message.match(regex)[0] === 0) return '';
          let isPlural = +message.match(regex)[0] > 1;

          let newMessage = message
            .replace(
              'Product Mispick',
              `Wrong product${isPlural ? 's' : ''} sent`,
            )
            .replace(
              'Truck Shortage',
              `Product${isPlural ? 's' : ''} not on the truck`,
            )
            .replace('Damaged Product', `Damaged product${isPlural ? 's' : ''}`)
            .replace(
              'Delivery Refusal',
              `Refused product${isPlural ? 's' : ''}`,
            );
          return newMessage;
        });
        messages = [
          messages[0],
          messages
            .slice(1)
            .filter(str => str)
            .join(','),
          '.',
        ];
      } else {
        this.messageTitle = this.notification?.messageTitle;
      }
      this.messageBody = messages?.join('');
    }
  }
}
